import {
  WORKER_CONFIG_FETCH_CONFIG_BEGIN,
  WORKER_CONFIG_FETCH_CONFIG_SUCCESS,
  WORKER_CONFIG_FETCH_CONFIG_FAILURE,
  WORKER_CONFIG_FETCH_CONFIG_DISMISS_ERROR,
} from './constants';

import axios from 'axios';
import moment from 'moment';
import { enqueueSnackbar, enqueueWarning, enqueueFailedRequestWarning} from '../../home/redux/snackActions'
import {makeDictionary} from '../../common/util'

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function fetchConfig(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: WORKER_CONFIG_FETCH_CONFIG_BEGIN,
    });

 const promise = new Promise((resolve, reject) => {
      let initialStateData = {};
      let dataRequests = [
                  axios.get("/api/config")
                ];
      
      let numPending = dataRequests.length;
      
      let failed = false;

      dataRequests.forEach(r => r.then(
        (res) => {
          numPending--;
          let data = res.data;
          
          Object.keys(data).forEach(k => 
            {
              console.log(k);
              if (Array.isArray(data[k]))
                initialStateData[k] = makeDictionary(data[k]);
              else
                initialStateData[k] = data[k];
            }
          );
          console.log({initialStateData});
          if (numPending === 0)
          {
            dispatch({
              type: WORKER_CONFIG_FETCH_CONFIG_SUCCESS,
              data: initialStateData,
            });
            resolve(initialStateData);
          }
          

        },
        
        (err) => {
          console.log({"what":"failed to fetch configuration"});
          
            //dispatch(enqueueFailedRequestWarning('Failed fetching data.',err));
          if (failed) return;
          failed = true;
          
          dispatch({
            type: WORKER_CONFIG_FETCH_CONFIG_FAILURE,
            data: { error: err },
          });
          
          //reject(err);
        },
      ));
        
    });


    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissFetchConfigError() {
  return {
    type: WORKER_CONFIG_FETCH_CONFIG_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case WORKER_CONFIG_FETCH_CONFIG_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchConfigPending: true,
        fetchConfigError: null,
      };

    case WORKER_CONFIG_FETCH_CONFIG_SUCCESS:
       let newState = {
        ...state,
        fetchConfigPending: false,
        fetchConfigError: null,
      };
      Object.keys(action.data).forEach(k => 
        newState[k] = action.data[k]);

      console.log({newState});
      return newState;

    case WORKER_CONFIG_FETCH_CONFIG_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchConfigPending: false,
        fetchConfigError: action.data.error,
      };

    case WORKER_CONFIG_FETCH_CONFIG_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchConfigError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/worker-config/redux/fetchConfig.js